export enum ILicenseStatus {
    NoLicense = 1,
    WillExpire,
    IsExpired,
    Valid
  
  }